import { Box } from '@material-ui/core'
import { useMemo } from 'react'

import {
  LayersConfig,
  LayersViewControl,
} from '@/components/map/layers-view-control'
import { LayerMap } from '@/hooks/queries/use-get-infestation-from-diagnosis'
import { transformUnderscoreInSpaceAndUppercaseFirstLetter } from '@/utils/format-strings'

interface ControlFillLayersProps {
  layersMap: LayerMap[]
  handleLayerChange: (layer: string, checked: boolean) => void
}

export function ControlFillLayers({
  layersMap,
  handleLayerChange,
}: ControlFillLayersProps) {
  const layersConfig = useMemo(
    () =>
      layersMap.reduce<LayersConfig>((acc, layer) => {
        acc[layer.name] = {
          label: (
            <Box display='flex' gridGap={8} alignItems='center'>
              <Box
                bgcolor={layer.colorPalette}
                minWidth={16}
                minHeight={16}
                maxWidth={16}
                maxHeight={16}
                borderRadius={4}
              />
              {transformUnderscoreInSpaceAndUppercaseFirstLetter(layer.name)}
            </Box>
          ),
          checked: !!layer.fillColor,
          disabled: false,
        }
        return acc
      }, {}),
    [layersMap],
  )

  return (
    <LayersViewControl
      layersConfig={layersConfig}
      onLayerChange={handleLayerChange}
      title={'Preenchimento de camadas'}
      defaultOpen
    />
  )
}
